var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.doc)?_c('v-row',{staticClass:"pt-5"},[_c('travel-results',{attrs:{"uid":this.uid,"pid":this.id}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }